module.exports = __webpack_public_path__ + "static/img/testDianpian2.c1de22d.png";